// Curated Kokoro-82M v1.0 voices with friendly labels.
export const KOKORO_VOICES = [
  { id: "af_heart", label: "Heart", accent: "US", gender: "Female" },
  { id: "af_bella", label: "Bella", accent: "US", gender: "Female" },
  { id: "af_nicole", label: "Nicole", accent: "US", gender: "Female" },
  { id: "af_aoede", label: "Aoede", accent: "US", gender: "Female" },
  { id: "af_kore", label: "Kore", accent: "US", gender: "Female" },
  { id: "af_sarah", label: "Sarah", accent: "US", gender: "Female" },
  { id: "af_sky", label: "Sky", accent: "US", gender: "Female" },
  { id: "am_adam", label: "Adam", accent: "US", gender: "Male" },
  { id: "am_michael", label: "Michael", accent: "US", gender: "Male" },
  { id: "am_echo", label: "Echo", accent: "US", gender: "Male" },
  { id: "am_eric", label: "Eric", accent: "US", gender: "Male" },
  { id: "am_fenrir", label: "Fenrir", accent: "US", gender: "Male" },
  { id: "am_liam", label: "Liam", accent: "US", gender: "Male" },
  { id: "am_onyx", label: "Onyx", accent: "US", gender: "Male" },
  { id: "am_puck", label: "Puck", accent: "US", gender: "Male" },
  { id: "bf_emma", label: "Emma", accent: "UK", gender: "Female" },
  { id: "bf_isabella", label: "Isabella", accent: "UK", gender: "Female" },
  { id: "bf_alice", label: "Alice", accent: "UK", gender: "Female" },
  { id: "bf_lily", label: "Lily", accent: "UK", gender: "Female" },
  { id: "bm_george", label: "George", accent: "UK", gender: "Male" },
  { id: "bm_daniel", label: "Daniel", accent: "UK", gender: "Male" },
  { id: "bm_fable", label: "Fable", accent: "UK", gender: "Male" },
  { id: "bm_lewis", label: "Lewis", accent: "UK", gender: "Male" },
];
